module.exports = __webpack_public_path__ + "web/img/verify9.2eecf0b2.jpg";